import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Select, Typography } from 'antd';
import { useUserSession } from '../../contexts/UserSessionContext';
import { useDashboard } from './DashboardContext';
import DashboardFilterBar from './DashboardFilterBar';

const { Text } = Typography;

export default function DashboardAssistantFilter({ filterKey = 'assistantId' }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showAll, isAdmin } = useDashboard();
  const { userAssistants, platformAssistants, assistantsLoaded } = useUserSession();

  const selectedId = searchParams.get(filterKey);
  const platformFlag = showAll && isAdmin;

  const assistants = useMemo(() => {
    const merged = platformFlag
      ? [...(userAssistants || []), ...(platformAssistants || [])]
      : [...(userAssistants || [])];
    const byId = new Map();
    merged.forEach((a) => byId.set(a.id, a));
    return Array.from(byId.values()).sort((a, b) =>
      (a.name || '').localeCompare(b.name || ''));
  }, [userAssistants, platformAssistants, platformFlag]);

  const selectedAssistant = assistants.find((a) => String(a.id) === selectedId);

  const handleChange = (value) => {
    const next = new URLSearchParams(searchParams);
    if (value) {
      next.set(filterKey, String(value));
    } else {
      next.delete(filterKey);
    }
    navigate({ search: next.toString() ? `?${next.toString()}` : '' }, { replace: true });
  };

  return (
    <div className="dashboard-assistant-filter">
      <DashboardFilterBar filters={[{ key: filterKey, label: 'Assistant' }]} />
      <div className="dashboard-assistant-filter__row">
        <Select
          allowClear
          showSearch
          placeholder="All assistants"
          style={{ minWidth: 220 }}
          loading={!assistantsLoaded}
          value={selectedId ? Number(selectedId) : undefined}
          onChange={handleChange}
          optionFilterProp="label"
          options={assistants.map((a) => ({
            value: a.id,
            label: a.name || `Assistant ${a.id}`,
          }))}
        />
        {selectedAssistant?.data_collection_id ? (
          <Text type="secondary" className="dashboard-assistant-filter__meta">
            Knowledge base linked
          </Text>
        ) : null}
      </div>
    </div>
  );
}
